<script>
    import { store } from '../../Store.svelte';
    import IzziMovilPlan from './IzziMovilPlan.svelte';
    import { calculateUsedWeight } from '../../utils/weightUtils';

    let plans = $store.requestedServices.product.extrasMap.movil2_0;
    plans = plans.filter(
        (elemento) =>
            !(
                elemento.extra.extName.replace(/\s+/g, '').toLowerCase() ===
                $store.requestedServices.product.nombreCode.toLowerCase()
            )
    );
    let maxLines = 5;

    const availablePlans = ['12 mes', 'familiar'];

    let shouldShowPlan = (plan) => {
        return (
            ((plan.extra.title &&
                !$store.requestedServices.isSpMovil &&
                availablePlans.some((title) =>
                    plan.extra.title.toLowerCase().includes(title.toLowerCase())
                )) ||
                $store.requestedServices.isSpMovil) &&
            plan.paqextVisible
        );
    };

    $: usedWeight = calculateUsedWeight($store.requestedServices.izzimovil);
    $: remainingLines = maxLines - usedWeight;
</script>

<div class="pure-g align-items-center m-b-30">
    <div class="pure-u-1-2 sm-m-b-20">
        <div class="h2 text-fs-20 fw-semibold m-b-25">
            Planes móviles disponibles
        </div>
    </div>
    <div class="pure-u-1-2 sm-m-b-20 text-center sm-only-text-left">
        <div class="">
            <p class="fw-semibold card-max-lines">
                Numero de líneas disponibles {remainingLines}/{maxLines}
            </p>
        </div>
    </div>
</div>

{#each plans as plan}
    {#if shouldShowPlan(plan)}
        <IzziMovilPlan item={plan} />
    {/if}
{/each}

<style>
    .card-max-lines {
        background-color: #f5f6f8;
        border-radius: 5px;
        padding: 5px;
        margin-top: 10px;
    }
</style>
